import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../accountant/accountant.service";
import { MyAccountService } from "./my-account-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { NotificationsService } from "src/app/dashboard/notifications.service";
import { HotToastService } from "@ngneat/hot-toast";
import { NgIf, NgFor } from "@angular/common";

declare var jQuery: any;

@Component({
    selector: "general-notification-settings-modal",
    templateUrl: "./general-notification-settings-modal.component.html",
    styleUrls: ["./general-notification-settings-modal.component.scss"],
    imports: [NgIf, NgFor]
})
export class GeneralNotificationSettingsModalComponent implements OnInit {
  user: any = {};
  data: any = {};
  workspaces: any = [];
  one_signal = window["OneSignal"] || [];
  has_web_push_enabled = null;
  loaded_count = 0;
  workspaces_count = 0;

  defaultFollowBehavior = true;
  followSettings = [];

  show_loading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private myAccountService: MyAccountService,
    private localStorage: LocalStorageService,
    private notificationService: NotificationsService,
    private toastr: HotToastService,
    public cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    this.one_signal = window["OneSignal"] || [];
    this.has_web_push_enabled = this.data["has_web_push_enabled"];
    this.one_signal.push(() => {
      //   Occurs when the user's subscription changes to a new value.
      this.one_signal.on("subscriptionChange", (isSubscribed) => {
        console.log("The user's subscription state is now:", isSubscribed);
        this.myAccountService.update_has_web_push(isSubscribed);
        this.one_signal.getUserId().then((userId) => {
          console.log("User ID is", userId);
          if (userId)
            this.myAccountService.set_push_keys({
              userId: userId,
              type: "WEB",
            });
        });
      });

      if (this.data.user_type == 1) {
        this.show_loading = true;
        this.getWorkspacesPaginated();
      }

      this.getNotificationSettings();

      // this.one_signal.isPushNotificationsEnabled().then(isEnabled => {
      //   console.log("is push enabled?", isEnabled);
      //   this.has_web_push_enabled = isEnabled;
      //   this.myAccountService.update_has_web_push(isEnabled);
      // });
    });
  }

  getWorkspacesPaginated(currLength = 0) {
    this.show_loading = true;
    this.accountantService
      .getWorkspacesPaginated(currLength)
      .then((res: any) => {
        this.workspaces = this.workspaces.concat(
          res.workspaces.filter((w: any) => w.archived === false)
        );
        this.loaded_count += res.workspaces.length;
        this.workspaces_count = res.count;
      })
      .then(() => (this.show_loading = false));
  }

  toggleWebPushNotifications() {
    this.has_web_push_enabled = !this.has_web_push_enabled;
    if (this.has_web_push_enabled) {
      this.one_signal.push(() => {
        console.log("Register For Push");
        this.one_signal.push(["registerForPushNotifications"]);
      });
    } else {
      this.myAccountService.update_has_web_push(this.has_web_push_enabled);
    }

    this.one_signal.getUserId().then((userId) => {
      console.log("User ID is", userId);
      if (userId) {
        console.log("sending push keys");
        this.myAccountService.set_push_keys({ userId: userId, type: "WEB" });
      }
    });
  }

  isFollowingWorkspace(conversationUuid: string): boolean {
    const idx = this.followSettings.findIndex(
      (f) => f.conversation === conversationUuid
    );
    if (idx !== -1) {
      return this.followSettings[idx].following;
    }
    return this.defaultFollowBehavior;
  }

  handleNotificationSettingsResponse(res: any) {
    /*
    {
      settings: [
        conversation: uuid,
        following: boolean
      ],
      default: boolean
    }
    */
    this.defaultFollowBehavior = res.default;
    this.followSettings = res.settings;
  }

  handleError(err: any) {
    this.toastr.error(err.error.message);
    this.show_loading = false;
  }

  getNotificationSettings() {
    this.notificationService.getFollowSettings().then(
      (res) => this.handleNotificationSettingsResponse(res),
      (err) => this.handleError(err)
    );
  }

  toggleConversationNotifications(conversationUuid: string) {
    this.show_loading = true;
    const val = !this.isFollowingWorkspace(conversationUuid);
    this.notificationService
      .setConversationFollowBehavior(conversationUuid, val)
      .subscribe(
        (res) => {
          const idx = this.followSettings.findIndex(
            (f) => f.conversation === conversationUuid
          );
          if (idx !== -1) {
            this.followSettings[idx].following =
              !this.followSettings[idx].following;
          } else {
            this.followSettings.push({
              conversation: conversationUuid,
              following: !this.defaultFollowBehavior,
            });
          }
          this.show_loading = false;
          this.toastr.success(res.message);
        },
        (err) => this.handleError(err)
      );
  }

  toggleDefaultConversationNotifications() {
    this.show_loading = true;
    this.notificationService
      .setDefaultFollowBehavior(!this.defaultFollowBehavior)
      .subscribe(
        (res) => {
          this.defaultFollowBehavior = !this.defaultFollowBehavior;
          this.cdr.detectChanges();
          this.show_loading = false;
          this.toastr.success(res.message);
        },
        (err) => this.handleError(err)
      );
  }
}
